import React from 'react';
import VegaMaintenance from '../components/VegaMaintenance';

const BikeMaintenancePage = () => {
  return <VegaMaintenance />;
};

export default BikeMaintenancePage;
